// extracted by mini-css-extract-plugin
module.exports = {"alert_danger__wrapper":"alert_alert_danger__wrapper__PiLHy","alert_danger__exclamation":"alert_alert_danger__exclamation__2DS4t"};